// STUB — Legacy org hook backed by Zustand store, for consumers expecting { loading, isAuthenticated, currentUser }.
// Primary consumers: debug/TestFlows.tsx
// TODO: Migrate callers to hooks/graphql/organizations/useOrganization.ts (GQL version).

import { useOrganizationStore } from '../../../stores/useOrganizationStore';
import { useAuthStore } from '../../../contexts/auth/useAuthStore';

export const useOrganizationCompat = () => {
  const { organization, loading } = useOrganizationStore();
  const { user: authUser } = useAuthStore();

  return {
    organization,
    loading,
    error: null as string | null,
    isAuthenticated: !!authUser,
    currentUser: authUser,
  };
};
